import { useHMSPeerId } from "../hms";
import { useLivekitPeerId } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderPeerId = (peerId: string) =>
  useProviderHook({
    hms: useHMSPeerId,
    livekit: useLivekitPeerId,
  })(peerId);
